import React, { Fragment, useEffect, useState } from 'react';
import TableCommon from '../../../../components/common/table/TableCommon';
import { useParams } from 'react-router-dom';
import * as CommonService from '../../../../services/CommonService';
import { SUPPLIER } from '../../../../services/endpoint';
import { message, Tag } from 'antd';
import { currencyVND, dateToString } from '../../../../utils';

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 1000000
};

export default () => {

	const { id } = useParams();
	const [ds, setDs] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [searchValues, setSearchValues] = useState({});

	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	useEffect(() => {
		const init = async () => {
			try {
				setLoading(true);
				const resp = await CommonService.get(`${SUPPLIER}/order-history/${id}`, {
					page: page.currentPage - 1,
					size: page.perpage
				});
				setDs(resp.data?.contents);
				setPage({ ...page, total: resp.data?.totalElements });
			} catch (error) {
				message.error(error?.data?.message || 'Có lỗi xảy ra');
			} finally {
				setLoading(false);
			}
		};
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(`${SUPPLIER}/order-history/${id}`, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã đơn nhập',
			dataIndex: 'purchaseOrderCode',
			align: 'center',
			width: 150
			// render: (text, record) => {
			// 	console.log(record);
			// 	return <Button style={{ padding: '0', height: 'fit-content' }} type={'link'}
			// 								 onClick={() => window.open('/supplier/' + record.id)}>{text}</Button>;
			// }
		},
		{
			title: 'Chi nhánh',
			dataIndex: 'branchName',
			width: 200,
			align: 'center'
		},
		{
			title: 'Giá trị',
			dataIndex: 'value',
			width: 250,
			align: 'center',
			render: (value) => currencyVND(value)
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			width: 110,
			align: 'center',
			render: (value) => value ? <Tag style={{ width: '110px' }} color="#87d068">Đang giao dịch</Tag> :
				<Tag style={{ width: '110px' }} color="#f50">Ngừng giao dịch</Tag>
		},
		{
			title: 'Ngày tạo đơn',
			dataIndex: 'createdDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Cập nhật cuối',
			dataIndex: 'updatedDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		}
	];

	return (
		<Fragment>
			<TableCommon
				loading={loading}
				bordered={true}
				page={page}
				setPage={setPage}
				datasource={ds}
				columns={columns}
				onSearch={onSearch}
				pagination={false}
			/>
		</Fragment>);
}
;

